<template>
    <div name="list" class="row">
        <div class="list">                        
            <card 
                v-for="(info, index) in vocPage.vocs"
                v-if="(index % 3) === 0"
                :number="info.order"
                :key="`card_${index}`"
                :info="info"
                :isLike="isUserLike(info.id)"
                :background="index % 2 === 0 ? 'background: var(--Gray-00, #FFF);': 'background: var(--Blue-04_Light-blue, #E5F0FC);'"
                @onLike="onLike(info.id)"
            />    
        </div>

        <div class="list">                        
            <card 
                v-for="(info, index) in vocPage.vocs"
                v-if="(index % 3) === 1"
                :number="info.order"
                :key="`card_${index}`"
                :info="info"
                :background="index % 2 === 0 ? 'background: var(--Gray-00, #FFF);': 'background: var(--Blue-04_Light-blue, #E5F0FC);'"
                :isLike="isUserLike(info.id)"
                @onLike="onLike(info.id)"
            />    
        </div>

        <div class="list">                        
            <card 
                v-for="(info, index) in vocPage.vocs"
                v-if="(index % 3) === 2"
                :number="info.order"
                :key="`card_${index}`"
                :info="info"
                :background="index % 2 === 0 ? 'background: var(--Gray-00, #FFF);': 'background: var(--Blue-04_Light-blue, #E5F0FC);'"
                :isLike="isUserLike(info.id)"
                @onLike="onLike(info.id)"
            />    
        </div>
    </div>
</template>

<script>
// voc list 무한스크롤 구현  
import {mapState} from 'vuex';
import Card from '@/components/molecules/pc_uncomfortable/Card'
import Cookie from '@/utilities/cookie';

export default {
    name: 'list',
    components: {
        Card,    
    },
    computed: mapState(['vocPage', 'vocLoginKakaoToken']),
    methods: {
        isUserLike: function(index)
        {
            if(this.vocLoginKakaoToken === null || this.vocLoginKakaoToken === undefined || this.vocLoginKakaoToken === '')
            {
                return false;
            }
            else
            {
                return this.isSavedValue(index);
                
            }
        },
        onLike: function(index)
        {
            if(this.vocLoginKakaoToken === null || this.vocLoginKakaoToken === undefined || this.vocLoginKakaoToken === '')
            {
                // login 필요
                this.$emit('login')
            }
            else
            {
                if(this.isSavedValue(index))
                {
                    return true;
                }
                else
                {
                    this.$emit('like', index)
                }
            }
        },
        isSavedValue: function(index)
        {
            // 검증 필요
            let likedata = JSON.parse(Cookie.getLocalStorageWithExpire("voclike"));

            if(likedata === null)
            {
                // like 검증하여 
                return false;
            }

            let ids = Cookie.getValueByKey(likedata, this.vocLoginKakaoToken);

            if(ids === null)
            {
                return false;
            }

            if(ids.length === undefined)
            {
                if(ids === index)
                {
                    return true;
                }
                else 
                {
                    // like 검증하여 
                    return false;
                }
            }
            else
            {
                if(ids.indexOf(index) > -1)
                {
                    return true;
                }
                else
                {
                    // like 검증하여 
                    return false;
                }
            }
        }
    }
}
</script>

<style scoped>
    .row {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        background: #212529;
        width: 831px;
    }
    .list {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 277px;
        justify-content: flex-start;
        align-items: center;
        background: #212529;
        
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/pc_uncomfortable/List.vue